module.exports = __webpack_public_path__ + "static/img/1_4.302a773.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/1_4.png
// module id = nmtI
// module chunks = 4